/**
 * Cart reserve timer: countdown in the cart drawer footer.
 * Persists end time in sessionStorage (survives refresh). Clears cart when time runs out.
 */
(function () {
  if (window.__cartReserveTimerInited) return;
  window.__cartReserveTimerInited = true;

  const CART_DRAWER_OPENING = 'fluco:modal:cartDrawer:opening';
  const CART_DRAWER_OPEN = 'fluco:modal:cartDrawer:open';
  const CART_CHANGED = 'cart:changed';
  const STORAGE_KEY = 'cartReserveEndTime';
  const MAX_INIT_RETRIES = 8;
  const RETRY_DELAY_MS = 80;

  let cartReserveTimerInterval = null;

  function clearCartAndDispatch() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => fetch('/cart.js'))
      .then((r) => r.json())
      .then((cart) => {
        sessionStorage.removeItem(STORAGE_KEY);
        if (cartReserveTimerInterval) {
          clearInterval(cartReserveTimerInterval);
          cartReserveTimerInterval = null;
        }
        document.dispatchEvent(
          new CustomEvent(CART_CHANGED, { detail: { cartData: cart }, bubbles: true })
        );
      });
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCartReserveTimer(retryCount) {
    const attempt = retryCount == null ? 0 : retryCount;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const wrapper = drawer.querySelector('.cart-drawer__reserve-message');
    if (!wrapper) {
      if (attempt < MAX_INIT_RETRIES) {
        setTimeout(() => initCartReserveTimer(attempt + 1), RETRY_DELAY_MS);
      }
      return;
    }

    if (cartReserveTimerInterval) {
      clearInterval(cartReserveTimerInterval);
      cartReserveTimerInterval = null;
    }

    const minutes = parseInt(wrapper.getAttribute('data-reserve-minutes') || 15, 10);
    let endTime = sessionStorage.getItem(STORAGE_KEY);
    if (endTime) endTime = parseInt(endTime, 10);
    else {
      endTime = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(STORAGE_KEY, String(endTime));
    }

    if (Date.now() >= endTime) {
      clearCartAndDispatch();
      return;
    }

    function updateDisplay(remainingMs) {
      const currentDrawer = document.querySelector('cart-drawer');
      if (!currentDrawer) return;
      const minEl = currentDrawer.querySelector('.cart-drawer__timer-min');
      const secEl = currentDrawer.querySelector('.cart-drawer__timer-sec');
      if (minEl && secEl) {
        const m = Math.floor(remainingMs / 60000);
        const s = Math.floor((remainingMs % 60000) / 1000);
        minEl.textContent = pad(m);
        secEl.textContent = pad(s);
      }
    }

    cartReserveTimerInterval = setInterval(() => {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        clearInterval(cartReserveTimerInterval);
        cartReserveTimerInterval = null;
        updateDisplay(0);
        clearCartAndDispatch();
        return;
      }
      updateDisplay(remaining);
    }, 1000);
    updateDisplay(endTime - Date.now());
  }

  function scheduleInit() {
    setTimeout(() => initCartReserveTimer(0), 50);
  }

  window.addEventListener(CART_DRAWER_OPENING, scheduleInit);
  window.addEventListener(CART_DRAWER_OPEN, scheduleInit);
  document.addEventListener(CART_CHANGED, scheduleInit);
})();
